export type LandmarkType = "userinterface" | "userinfo" | "action" | "carousel";

export interface Landmark {
    landmark: LandmarkType;
}

export interface ClickLandmark extends Landmark {
    click: string;
}

export class SustainabilityStandardDetailLandmark implements ClickLandmark {
    readonly landmark: LandmarkType = "userinterface";
    readonly click: string = "adp_sustainability_product_standards";
}
